module.exports = __webpack_public_path__ + "static/media/sweep.bada36a3.mp4";